<template>
  <div>
    <Editor
      :visible.sync="visible"
      :dataSource="current"
      :type="type"
      @confirm="handleConfirm"
    />

    <Perm
      :visible.sync="visiblePerm"
      :selected="selectedPerms"
      @confirm="handlePermConfirm"
    />

    <Button
      v-if="canAddRole"
      style="margin-bottom: 20px; float: right;"
      type="primary"
      @click="create"
    >
      新增角色
    </Button>
    <Table
      v-if="canRoleList"
      :data="data"
    >
      <TableColumn
        prop="id"
        label="ID"
      />
      <TableColumn
        prop="name"
        label="角色名称"
      />
      <TableColumn
        label="操作"
      >
        <template slot-scope="scope">
          <Button
            v-if="canAttachPerms"
            type="text"
            size="small"
            @click="perm(scope.row)"
          >
            编辑权限
          </Button>
          <Button
            v-if="canEditRole"
            type="text"
            size="small"
            @click="update(scope.row)"
          >
            修改
          </Button>
          <Button
            v-if="canDeleteRole"
            type="text"
            size="small"
            @click="remove(scope.row)"
          >
            删除
          </Button>
        </template>
      </TableColumn>
    </Table>
  </div>
</template>

<script>
import { Table, TableColumn, Button } from 'element-ui';

import Editor from './Editor';
import Perm from './Perm';

import requestMixin from './mixins/request';

export default {
  components: {
    Table,
    TableColumn,
    Button,
    Editor,
    Perm,
  },

  mixins: [requestMixin],

  data() {
    return {
      data: [],
      visible: false,
      visiblePerm: false,
      current: null,
      type: 'add',
      selectedPerms: [],
    };
  },

  computed: {
    perms() {
      return this.$store.state.perms;
    },

    canAddRole() {
      return this.perms.includes('AddRole');
    },

    canRoleList() {
      return this.perms.includes('RoleList');
    },

    canEditRole() {
      return this.perms.includes('EditRole');
    },

    canDeleteRole() {
      return this.perms.includes('DeleteRole');
    },

    canAttachPerms() {
      return this.perms.includes('AttachPerms');
    },
  },

  created() {
    this.userRoleList();
  },

  methods: {
    create() {
      this.type = 'add';
      this.visible = true;
    },

    update(data) {
      this.current = data;
      this.type = 'update';
      this.visible = true;
    },

    remove(data) {
      this.$confirm('你确定要删除当前角色吗？').then(() => {
        this.userRoleDelete({ id: data.id });
      });
    },

    perm(data) {
      this.current = data;
      this.visiblePerm = true;
      this.userRoleGetPerms({ role_id: data.id });
    },

    handleConfirm(data) {
      if (this.type === 'add') {
        this.userRoleAdd(data);
      } else if (this.type === 'update') {
        data.id = this.current.id;
        this.userRoleEdit(data);
      }
    },

    handlePermConfirm(data) {
      this.userRoleAttachPerms({
        role_id: this.current.id,
        perm_ids: data,
      });
    },
  },
};
</script>